import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  IVideoResponse,
  IVideoResponseModel
} from './models/videos-and-events-model';
import { Observable } from 'rxjs';
import {
  IPagination,
  PaginationProps
} from 'src/app/shared/interfaces/pagination';
import { injectQuery } from '@ngneat/query';
import { ICategoryModel } from './models/category-model';

@Injectable({
  providedIn: 'root'
})
export class VideosAndEventsService {
  private apiUrl = `${environment.baseApimUrl}/videos`;

  private query = injectQuery();

  constructor(private http: HttpClient) {}

  async getAllVideos(): Promise<IVideoResponse> {
    const response = await this.fetchVideos({
      page: 1,
      pageSize: 1000
    }).toPromise();
    return {
      rows: response.items,
      totalCount: response.totalCount
    };
  }

  getPagedCategories(params: PaginationProps<{ ignoreIdCategory?: string }>) {
    return this.query({
      queryKey: ['videos-and-events-paged-categories', params],
      queryFn: () => this.fetchCategories(params)
    });
  }

  getVideosWithQuery(
    params: PaginationProps<{
      categoryId?: string;
      title?: string;
      //   summary?: string;
    }>
  ) {
    return this.query({
      queryKey: ['videos-and-events-category', params],
      queryFn: () => this.fetchVideos(params)
    });
  }

  private fetchCategories({
    page,
    pageSize,
    ignoreIdCategory
  }: PaginationProps<{ ignoreIdCategory?: string }>): Observable<
    IPagination<ICategoryModel>
  > {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    if (ignoreIdCategory)
      params.append('ignoreIdCategory', ignoreIdCategory.toString());

    const url = `${this.apiUrl}/categorias?${params.toString()}`;
    return this.http.get<IPagination<ICategoryModel>>(url);
  }

  private fetchVideos({
    page,
    pageSize,
    orderBy,
    categoryId,
    title
    // summary
  }: PaginationProps<{
    categoryId?: string;
    title?: string;
    // summary?: string;
  }>): Observable<IPagination<IVideoResponseModel>> {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    if (orderBy) params.append('orderBy', orderBy);
    if (categoryId) params.append('categoryId', categoryId);
    if (title) params.append('title', title);
    // if (summary) params.append('summary', summary);

    const url = `${this.apiUrl}?${params.toString()}`;
    return this.http.get<IPagination<IVideoResponseModel>>(url);
  }

  getVideoOrEvent(id: string): Observable<IVideoResponseModel> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<IVideoResponseModel>(url);
  }
}
